import { Box, Typography, Grid, Button, Link } from "@mui/material";
import styled from "styled-components";
import LeftArrow from "@assets/svg/AppMarketLeftArrow.svg?react";

export interface IDirectionProps {
  $isRtl: boolean;
  $active?: boolean;
}

// Main container styles
export const Container = styled(Box)`
  width: 100%;
`;

export const TitleContainer = styled(Box)<IDirectionProps>`
  width: 582px;
  height: ${(props) => (props.$isRtl ? "74px" : "90px")};
  gap: 16px;
`;

export const MainTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "20px",
    color: "#130080",
  },
})``;

export const SubTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "16px",
    color: "#adbac7",
  },
})``;

export const MainSection = styled(Box)`
  margin-top: 40px;
  height: fit-content;
  background-color: white;
  border-width: 1px;
  border-radius: 10px;
  gap: 24px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  padding-block: 20px;
`;

// App header section
export const AppHeaderBox = styled(Box)`
  margin-top: 0px;
  display: flex;
  height: auto;
  border-bottom: 1px solid #e3e8ef;
  margin-inline: 20px;
  gap: 16px;
`;

export const AppLogo = styled.img<IDirectionProps>`
  border: ${(props) => (props.$active ? "2px solid #5b3fff" : "none")};
  border-radius: ${(props) => (props.$active ? "8px" : "none")};
  width: 128px;
  height: 128px;
  margin-bottom: 24px;
`;

export const AppInfoContainer = styled(Box)`
  height: 128px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 4px;
`;

export const AppName = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "18px",
    color: "#121926",
  },
})``;

export const AppDescription = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
    width: "943px",
  },
})``;

export const ButtonContainer = styled(Box)`
  height: 41px;
  padding-bottom: 20px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: start;
  margin-top: 15px;
`;

export const PrimaryButton = styled.button<IDirectionProps>`
  width: ${(props) => (props.$isRtl ? "129px" : "fit-content")};
  height: 41px;
  border-radius: 8px;
  background-color: ${(props) => (!props.$active ? "#5b3fff" : "#16AE26")};
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
`;

export const SecondaryButton = styled.button<IDirectionProps>`
  font-weight: 700;
  font-size: 14px;
  width: ${(props) => (props.$isRtl ? "129px" : "fit-content")};
  height: 41px;
  border-radius: 8px;
  border: 1px solid #5b3fff;
  background-color: #ffffff;
  color: #5b3fff;
  cursor: pointer;
`;

export const CustomerServiceLink = styled.span<IDirectionProps>`
  display: flex;
  flex-direction: ${(props) => (!props.$isRtl ? "row-reverse" : "row")};
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14.3px;
  color: #5b3fff;
  gap: 10px;
  cursor: pointer;
`;

export const ArrowIcon = styled(LeftArrow)`
  width: 18px;
  height: 18px;
`;

// Benefits section
export const BenefitsSection = styled(Box)<IDirectionProps>`
  background: linear-gradient(0deg, #fafafb, #fafafb),
    linear-gradient(
      180deg,
      rgba(91, 63, 255, 0.05) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  width: 1087px;
  height: ${(props) => (props.$isRtl ? "615px" : "635px")};
  border-radius: 40px;
  margin-inline: 20px;
  margin-top: 20px;
  display: flex;
  align-items: start;
  padding: 34px;
  justify-content: space-between;
`;

export const BenefitsTextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const BenefitsContent = styled(Box)`
  width: 446px;
  height: 114px;
`;

export const BenefitsTitle = styled(Typography).attrs({
  sx: {
    marginBottom: "10px",
    fontWeight: 700,
    fontSize: "20px",
    color: "#27262c",
  },
})``;

export const BenefitsDescription = styled(Typography).attrs({
  sx: {
    fontWeight: 500,
    fontSize: "16px",
    color: "#435363",
  },
})``;

export const IconWrapper = styled(Box)`
  background-color: #ffffff;
  padding: 5px;
  width: 40px;
  height: 40px;
  border-radius: 5.12px;
  margin-top: 24px;
`;

export const MappedDiv = styled.div`
  margin-top: 24px;
`;

export const BenefitTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "16px",
    color: "#435363",
  },
})``;

export const BenefitDescription = styled(Typography).attrs({
  sx: {
    fontWeight: 500,
    fontSize: "16px",
    color: "#435363",
  },
})``;

export const BenefitImage = styled.img`
  width: 516px;
  height: 322px;
  border-radius: 10.42px;
`;

// Related apps section
export const RelatedAppsBox = styled(Box)`
  border-top: 1px solid #e9e9e7;
  padding-top: 24px;
  margin-inline: 20px;
  margin-top: 55px;
`;

export const RelatedAppsHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  padding-inline: 40px;
`;

export const RelatedAppsTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "20px",
    color: "#27262c",
  },
})``;

export const RelatedAppsSubtitle = styled(Typography).attrs({
  sx: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#435363",
  },
})``;

export const RelatedAppsGrid = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
`;

export const LogoSkeleton = styled.div`
  width: 128px;
  height: 128px;
  margin-bottom: 24px;
`;

export const PrimaryButtonSkeleton = styled.div<{ isRtl: boolean }>`
  width: ${({ isRtl }) => (isRtl ? "129px" : "160px")};
  height: 41px;
  border-radius: 8px;
`;

export const SecondaryButtonSkeleton = styled.div<{ isRtl: boolean }>`
  width: ${({ isRtl }) => (isRtl ? "129px" : "180px")};
  height: 41px;
  border-radius: 8px;
`;

export const CustomerServiceSkeleton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 160px;
  height: 20px;
`;
export const SkeletonSection = styled.div`
  width: 516px;
  height: 322px;
  border-radius: 10.42px;
`;
